import { track } from '@vercel/analytics';

export const trackVercel = (eventName, properties = {}) => {
  // Only send events in production
  if (import.meta.env.VITE_PUBLIC_APP_ENV !== 'production') {
    console.log('Vercel Analytics Event (dev):', eventName, properties);
    return;
  }

  track(eventName, properties);
};

// Auth events
export const trackVercelSignIn = (method) => {
  trackVercel('user_signed_in', {
    auth_method: method,
    timestamp: new Date().toISOString()
  });
};

export const trackVercelSignOut = () => {
  trackVercel('user_signed_out', {
    timestamp: new Date().toISOString()
  });
};

// Page view events
export const trackVercelPageView = (pageName, properties = {}) => {
  trackVercel('page_view', {
    page_name: pageName,
    timestamp: new Date().toISOString(),
    ...properties
  });
};

// Repository events
export const trackVercelRepositoryAction = (action, repositoryData = {}) => {
  trackVercel('repository_action', {
    action,
    timestamp: new Date().toISOString(),
    ...repositoryData
  });
};

// Conversation events
export const trackVercelConversationAction = (action, conversationData = {}) => {
  trackVercel('conversation_action', {
    action,
    timestamp: new Date().toISOString(),
    ...conversationData
  });
};

// User identification for Vercel (simpler than PostHog)
export const trackVercelUserIdentification = (userId, userProperties = {}) => {
  trackVercel('user_identified', {
    user_id_hash: userId, // Assume this is already hashed
    has_email: !!userProperties.email,
    identified_at: new Date().toISOString()
  });
}; 